import React from 'react';
import ArrowIcon from 'images/dropbox/arrow.png';
import styles from './index.scss';

type Props = {
  path: string
};

const FolderPath = (props: Props) => {
  const { path } = props;
  const parts = path.split('/');
  if (!parts[0]) {
    parts.shift(); // remove first item
  }
  const pathMarkup = parts.map((part, i) => {
    return (<span key={`path-${i}`}> <img src={ArrowIcon} className={styles.arrow} /> {part}</span>);
  });

  // pathMarkup will only render if default save path is NOT root
  return <div>Dropbox {path !== '/' && pathMarkup}</div>;
};

export default FolderPath;
